import { useState } from 'react';
import { RefreshCw } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip';
import { APP_VERSION } from '@/lib/version';
import { toast } from 'sonner';

export function RefreshAppButton() {
  const [busy, setBusy] = useState(false);

  const handleRefresh = async () => {
    if (busy) return;
    setBusy(true);
    try {
      // Unregister all service workers
      if ('serviceWorker' in navigator) {
        const regs = await navigator.serviceWorker.getRegistrations();
        await Promise.all(regs.map((r) => r.unregister().catch(() => false)));
      }
      // Clear cache storage
      if ('caches' in window) {
        const keys = await caches.keys();
        await Promise.all(keys.map((k) => caches.delete(k).catch(() => false)));
      }
    } catch (e) {
      // best-effort; continue to reload regardless
      console.warn('[RefreshAppButton] cleanup error', e);
    } finally {
      const url = new URL(window.location.href);
      url.searchParams.set('_v', Date.now().toString());
      window.location.replace(url.toString());
    }
  };

  return (
    <TooltipProvider delayDuration={200}>
      <div className="fixed bottom-16 right-4 z-[70] flex items-center gap-2 pointer-events-none">
        <Tooltip>
          <TooltipTrigger asChild>
            <Button
              variant="glass"
              size="icon"
              onClick={handleRefresh}
              disabled={busy}
              aria-label="Refresh to latest version"
              className="rounded-full shadow-lg pointer-events-auto"
            >
              <RefreshCw className={`w-4 h-4 ${busy ? 'animate-spin' : ''}`} />
            </Button>
          </TooltipTrigger>
          <TooltipContent side="left">
            <p className="text-xs">Refresh to latest version</p>
          </TooltipContent>
        </Tooltip>
      </div>
    </TooltipProvider>
  );
}

export default RefreshAppButton;
